import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownLeftContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M14.41 16.496a1 1 0 1 0 .18-1.992l-.09.996zM9 15l-.996.09a1 1 0 0 0 .905.906zm.496-5.59a1 1 0 1 0-1.992.18L8.5 9.5zm6.211.297a1 1 0 0 0-1.414-1.414L15 9zM14.5 15.5l.09-.996-5.5-.5L9 15l-.09.996 5.5.5zM9 15l.996-.09-.5-5.5-.996.09-.996.09.5 5.5zm0 0 .707.707 6-6L15 9l-.707-.707-6 6zm3 6.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm9.6 9.6h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6z"
    />
  </svg>
);
export default SvgArrowDownLeftContained;
